import { render, staticRenderFns } from "./send-coupon.vue?vue&type=template&id=1a0e4180&scoped=true&"
import script from "./send-coupon.vue?vue&type=script&lang=ts&"
export * from "./send-coupon.vue?vue&type=script&lang=ts&"
import style0 from "./send-coupon.vue?vue&type=style&index=0&id=1a0e4180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e4180",
  null
  
)

export default component.exports